import { FlexFileError } from './FlexFileError';

import {ReportDataService} from '../../report-data.service';

export class UnitOrSubunitAllocationError extends FlexFileError {

  protected reportService: ReportDataService;

  constructor(reportService: ReportDataService) {
    super(reportService, 'Unit or Subunit Item Needs Allocation', 'UNIT_OR_SUBUNIT_ALLOCATION', 0, false, null);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/errors/UnitOrSublotAllocationError.ts